import decodeJwt from 'jwt-decode';

const cashbackAdmin = process.env.REACT_APP_ROLE_CASHBACK_MANAGER,
    decodedToken = localStorage.getItem('authenticateToken') ?
        decodeJwt(localStorage.getItem('authenticateToken')) : null;

export default decodedToken ? decodedToken.roles.some(role => role === cashbackAdmin) : false;